import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Grid, Button } from 'semantic-ui-react'
import Server from '../../../functions/server'
import $ from "jquery";
import CircularProgress from '@material-ui/core/CircularProgress';

class EditPartAlias extends React.Component {

  state = {
    part_alias: this.props.alias,
    mrp: this.props.mrp,
    dnp: this.props.dnp,
    load: false,
    message: '',
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  update() {
    let context = this;
    let part_alias = this.state.part_alias;
    let mrp = this.state.mrp;
    let dnp = this.state.dnp;
    if (part_alias == '' || part_alias == null || part_alias == undefined) {
      this.setState({ error: 'Enter the Alias name!!!' });
      return;
    }
    if (mrp == '' || mrp == null || mrp == undefined) {
      this.setState({ error: 'Enter the MRP!!!' });
      return;
    }
    if (dnp == '' || dnp == null || dnp == undefined) {
      this.setState({ error: 'Enter the DNP!!!' });
      return;
    }
    let data1 = { 'editId': this.props.editId, 'alias': part_alias, 'mrp': mrp,
                  'dnp': dnp, 'brand_id': this.props.brandId, 'partno': this.props.partno };
    context.setState({
      load: true,
      message: 'Editing alias!!!'
    })
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/editaliasname.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.props.getBrandById();
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    const { load } = this.state;
    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <form noValidate autoComplete="off">
              <TextField
                id="outlined-name"
                label="Part Alias"
                value={this.state.part_alias}
                onChange={this.handleChange('part_alias')}
                margin="normal" fullWidth
                variant="outlined"
              />
            </form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <form noValidate autoComplete="off">
              <TextField
                id="outlined-name"
                label="DNP"
                value={this.state.dnp}
                onChange={this.handleChange('dnp')}
                margin="normal" fullWidth
                variant="outlined"
              />
            </form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <form noValidate autoComplete="off">
              <TextField
                id="outlined-name"
                label="MRP"
                value={this.state.mrp}
                onChange={this.handleChange('mrp')}
                margin="normal" fullWidth
                variant="outlined"
              />
            </form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <center><div style={{color: 'red'}}>{this.state.error}</div></center>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={ () => { this.props.handleClose(); }}>CANCEL</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            {load ?
              (<div><center><CircularProgress size={18} color='secoundary' /></center></div>)
             :
              (<div><Button fluid onClick={this.update.bind(this)}>SUBMIT</Button></div>)
            }
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default EditPartAlias;
